<script lang="ts">
  import SidePanelInnerLayout from "$components/+layout/SidePanel/SidePanelInnerLayout.svelte";
  import OVIcon from "$components/+blocks/OVIcon/OVIcon.svelte";
  import Separator from "$components/+blocks/Separator/Separator.svelte";
  import Avatar from "$components/+blocks/Avatar/Avatar.svelte";
  import SemanticSectionPanel from "$components/ai/semantic/SemanticSectionPanel.svelte";
  import SemanticEmptyState from "$components/ai/semantic/SemanticEmptyState.svelte";
  import Spinner from "$components/+blocks/Spinner/Spinner.svelte";
  import LoadingAtom from "$components/+blocks/Loading/LoadingAtom.svelte";
  import { semanticFlag } from "$stores/community";
  import {
    isSemanticDataFetched,
    replyPanel,
    replyThread,
    replyUuid,
    semanticDiscussions,
    semanticDocuments,
    semanticRelations,
  } from "$stores/replyPanel";
  import ReplyPanelCard from "./ReplyPanelCard.svelte";
  import { Right, Squircle } from "$components/+blocks/OVIcon";
</script>

<SidePanelInnerLayout>
  <span slot="title" class="inline-flex items-center gap-[5px] text-sm font-medium">
    <span
      class="max-w-[20ch] truncate text-neutral-500/60 dark:text-neutral-400"
      title={$replyThread?.title}
    >
      {#if $replyThread}
        {$replyThread?.title}
      {:else}
        <LoadingAtom size={"h-4 w-24"} />
      {/if}
    </span>
    <OVIcon
      icon={Right}
      size="size-3.5"
      class="-ml-1 shrink-0 text-neutral-500/60 dark:text-neutral-400"
    />
    <span class="text-neutral-500 dark:text-neutral-300">Reply</span>
  </span>

  <svelte:fragment slot="content">
    <div class="items-left flex flex-col gap-4 px-6 py-8 text-sm md:text-[13px]">
      <ReplyPanelCard reply={$replyPanel} />

      <div class="mt-2 flex items-center">
        <span class="basis-1/4 pr-4 text-neutral-500/80 dark:text-neutral-400">Forum</span>
        <span
          class="flex items-center gap-1.5 overflow-hidden text-neutral-500 dark:text-neutral-300"
        >
          {#if $replyThread?.forumSpace.icon}
            <Avatar mainImage={$replyThread?.forumSpace.icon} radius="rounded-[3px]" />
          {:else}
            <span style="color: {$replyThread?.forumSpace.color}">
              <OVIcon icon={Squircle} class="shrink-0" />
            </span>
          {/if}
          <span class="truncate">
            {#if $replyThread}
              {$replyThread.forumSpace.title}
            {:else}
              <LoadingAtom size="h-4 w-24" />
            {/if}
          </span>
        </span>
      </div>

      <div class="flex items-center">
        <span class="basis-1/4 pr-4 text-neutral-500/80 dark:text-neutral-400">Author</span>
        <span
          class="flex items-center gap-1.5 overflow-hidden text-neutral-500 dark:text-neutral-300"
        >
          {#if $replyThread}
            <Avatar
              mainImage={$replyThread?.author.profileImage}
              label={$replyThread?.author.handle[0]}
              radius="rounded"
              backgroundColor={$replyThread?.author.profileColor}
            />
          {:else}
            <LoadingAtom size="size-4" />
          {/if}

          <span class="truncate">
            {#if $replyThread}
              {$replyThread?.author.handle}
            {:else}
              <LoadingAtom size="h-4 w-24" />
            {/if}
          </span>
        </span>
      </div>

      <div class="flex items-center">
        <span class="basis-1/4 pr-4 text-neutral-500/80 dark:text-neutral-400">Posted</span>
        <span class="truncate text-neutral-500 dark:text-neutral-300">
          {#if $replyThread}
            <span class="truncate">
              {new Date($replyThread?.created).toLocaleDateString("en-UK", {
                day: "numeric",
                month: "short",
                year: "numeric",
              })}
            </span>
          {:else}
            <LoadingAtom size={"h-4 w-24"} />
          {/if}
        </span>
      </div>
    </div>

    {#if $semanticFlag && $replyUuid}
      <Separator />
      {#if !$isSemanticDataFetched}
        <div class="mx-auto mt-24 h-[75px]">
          <Spinner frequency={2} />
        </div>
      {:else if $semanticDocuments.length || $semanticDiscussions.length}
        <SemanticSectionPanel relations={$semanticRelations} />
      {:else}
        <SemanticEmptyState />
      {/if}
    {/if}
  </svelte:fragment>
</SidePanelInnerLayout>
